import _ from 'lodash';

export const parseTimeToObject = (apiTIme) => {
  const timeArray = _.split(apiTIme, ':', 2);
  return {
    hour: timeArray[0],
    minute: timeArray[1],
  };
};

export const prepareTimeForAPI = timeString => `${timeString}:00`;

export const timeFormat = 'HH:mm';

export const defaultTime = {
  alertStart: {
    hour: 0,
    minute: 0,
  },
  alertEnd: {
    hour: 23,
    minute: 59,
  },
};

export default {
  parseTimeToObject,
  prepareTimeForAPI,
};
